import React from 'react';
import './Gospel.css'; // Import the CSS file for styling

const Gospel = () => {
  return (
    <div id='gospel-main-container'>
    <section className="gospel-section">
      <div className="container">
        <h2 className="section-title">Let's Make Gospel together</h2>
        <div className="gospel-content">
          
          <div className="gospel-text">
            <p>
             We are a community of believers dedicated
              to spreading the love and teachings of Jesus Christ. Our mission
              is to serve our local community and provide a place of worship
              where people can come together and grow in their faith.
            </p>
           
           
          </div>
        </div>
      </div>
      </section>
      </div>
   
  );
};

export default Gospel;
